import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {company} from './../../services/api/api'

// Models

export interface initailState {
    company:company | null,
    isLoaded:boolean,
    isFetching:boolean,
    isLoading:boolean
}
let initialCompanyState:initailState = {
  company: { "id": 1,
    "name": "Rawashen",
    "commercial_name": "Rawashen",
    "country": "Saudi Arabia",
    "city": "Dammam",
    "post_code": "00000",
    "address": "NA",
    "email": "NA",
    "phone": "NA",
    "fax": "NA",
    "website": "Na",
    "description": "Na",
    "logo": "",
    "created_at": null,
    "updated_at": null,
    "tax_number": "34243253643",
    "tax_percent": "15.00",
    country_ar:'',
    city_ar:'',
    address_ar:'',
    name_ar:'',
    commercial_registrar_number:'',
    commercial_name_ar:''
},
    isFetching:false,
    isLoaded:false,
    isLoading:false
    
}
// Orders slice
export const companySlice = createSlice({
    name: 'orders',
    initialState: initialCompanyState,
    reducers: {
        setIsLoaded: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoaded = payload
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsFetching: (state, { payload }: PayloadAction<boolean>) => {
            state.isFetching = payload
        },
    
        addCompany: (state, { payload }: PayloadAction<company>) => {
            state.company =   payload
        },
         updateCompany: (state, { payload }: PayloadAction<company>) => {
            state.company=payload
         },
        // setIsLoadingOrder: (state, { payload }: PayloadAction<{ id: number, isLoading: boolean }>) => {
        //     let index = state.orders[state.page]
        //     .findIndex(order => order.id === payload.id)
        //     if (index !== -1)
        //         state.orders[state.page][index].isLoading = payload.isLoading
        // },
         deleteCompany: (state, { payload }: PayloadAction<number[]>) => {
             state.company=null
             
      
         },
        reset: (state) => {
            state.company = null
            
        },
        // updateInvoiceIssued:(state,{payload}:PayloadAction<{ id: number, invoice_issued: boolean }>)=>{
        //     let index = state.orders[state.page].findIndex(order => order.id === payload.id)
        
        //     if (index !== -1) state.orders[state.page][index].invoice_issued=payload.invoice_issued
        //  },
        //  updateDeliveryOrderIssued:(state,{payload}:PayloadAction<{ id: number, delivery_order_issued: boolean }>)=>{
        //     let index = state.orders[state.page].findIndex(order => order.id === payload.id)
        //     if (index !== -1) state.orders[state.page][index].delivery_order_issued=payload.delivery_order_issued
        //  },
        //  updateJobOrderPrinted:(state,{payload}:PayloadAction<{id:number,job_order_printed:boolean}>)=>{
        //     let index = state.orders[state.page].findIndex(order => order.id === payload.id)
        //     if (index !== -1) state.orders[state.page][index].job_order_printed=payload.job_order_printed
        //  },
        //  setPage:(state,{payload}:PayloadAction<number>)=>{
        //     state.page=payload
        // }
    }
})